// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3ylpg","title":"ClientInsurance_title__xdZJG","itemText":"ClientInsurance_itemText__2N7Mc"};